var _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMoneyWithdrawal(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.91406 11.4575C7.91406 12.2659 8.53907 12.9159 9.30574 12.9159H10.8724C11.5391 12.9159 12.0808 12.3492 12.0808 11.6409C12.0808 10.8825 11.7474 10.6075 11.2558 10.4325L8.7474 9.55755C8.25573 9.38255 7.9224 9.11589 7.9224 8.34922C7.9224 7.64922 8.46406 7.07422 9.13072 7.07422H10.6974C11.4641 7.07422 12.0891 7.72422 12.0891 8.53256",
    stroke: "white",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10 6.25V13.75",
    stroke: "white",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M18.3308 10.0013C18.3308 14.6013 14.5974 18.3347 9.99737 18.3347C5.3974 18.3347 1.66406 14.6013 1.66406 10.0013C1.66406 5.4013 5.3974 1.66797 9.99737 1.66797",
    stroke: "white",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M18.3281 5.00391L18.3281 1.67058L14.9948 1.67058",
    stroke: "white",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M14.1614 5.83594L18.3281 1.66928",
    stroke: "white",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMoneyWithdrawal);
export default __webpack_public_path__ + "static/media/money-withdrawal.0fac0658ef21ca5d2e9f46563b48f9e0.svg";
export { ForwardRef as ReactComponent };